import React from 'react';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { MobileHeader } from './mobile';
import { DesktopHeader } from './desktop';
import { IOfficeHeaderInfo } from 'screens/AgentOfficePages/types';


export const Header: React.FC<IOfficeHeaderInfo> = (props) => {
  const isMobile = useScreenBreakpoint() === 1;

  return isMobile ? <MobileHeader {...props} /> : <DesktopHeader {...props} />;
};
